export function VendorInvoiceSerialNumbersCtrl (
  $uibModalInstance,
  $q,
  $scope,
  $translate,
  bigDecimalApi,
  confirm,
  crudGridAPI,
  editable,
  item,
  messages,
  serial_numbers,
  workshopAPI
) {

  $scope.item           = item || [];
  $scope.serial_numbers = serial_numbers || [];

  $scope.crudGridAPI      = crudGridAPI();
  $scope.crudGridAPI.data = $scope.serial_numbers;
  $scope.editable         = editable;

  $scope.addNumber = function () {
    const unsavedIndex = $scope.crudGridAPI.data.findIndex(data => data.unsaved);

    $q.when()
    .then(() => unsavedIndex >= 0
      ? $scope.saveNumber($scope.crudGridAPI.data[ unsavedIndex ], unsavedIndex)
        .then(() => {
          $scope.crudGridAPI.data[ unsavedIndex ].unsaved = false;

          return $q.when(true);
        })
      : $q.when(true))
    .then(() => {
      $scope.crudGridAPI.addRow();

      $scope.crudGridAPI.data[ $scope.crudGridAPI.data.length - 1 ].unsaved = true;
    });
  };

  $scope.cancelEdit = function ( number, index ) {
    $scope.crudGridAPI.data[ index ].unsaved = false;

    $scope.crudGridAPI.toggleEditMode(number, index);

    $scope.form.$setPristine();
  };

  $scope.close = function () {
    const quantity      = bigDecimalApi.get($scope.item.quantity);
    const serialNumbers = bigDecimalApi.get($scope.serial_numbers.length);

    if (serialNumbers.isLessThan(quantity)) {
      return confirm.generic($translate.instant('SERIAL_NUMBER_SPACE.ADDED_NOT_ENOUGH'))
        .then(() => $uibModalInstance.close());
    }

    $uibModalInstance.close();
  };

  $scope.deleteNumber = function (number, index) {
    $q.when()
    .then(() => {
      return number.id ?
        confirm.generic($translate.instant('SERIAL_NUMBER_SPACE.DELETE_CONFIRM')) :
        $q.when(true);
    })
    .then(() => $scope.crudGridAPI.removeRow(number, index, '/product_serial_numbers', 'id'))
    .then(() => {
      messages.show($translate.instant('SERIAL_NUMBER_SPACE.DELETED'), 'success');

      $scope.crudGridAPI.data.splice(index, 1);
    });
  };

  $scope.editNumber = function ( number, index ) {
    $scope.crudGridAPI.data[ index ].unsaved = true;

    $scope.crudGridAPI.toggleEditMode(number, index);
  };

  $scope.saveNumber = function ( number, index ) {
    return $q.when()
    .then(() => {
      const quantity      = bigDecimalApi.get($scope.item.quantity);
      const serialNumbers = bigDecimalApi.get($scope.serial_numbers.length);

      return serialNumbers.isGreaterThan(quantity) ?
        $q.reject($translate.instant('SERIAL_NUMBER_SPACE.ADDED_MORE_THAN_REQUIRED')) :
        $q.when(true);
    })
    .then(() => {
      const options = number.id ? {
        method: 'patch',
        url   : '/product_serial_number'
      } : {
        method: 'post',
        url   : '/product_serial_numbers'
      };

      return workshopAPI[ options.method ](options.url, {
        id                    : number.id,
        product_id            : $scope.item.product_id,
        serial_number         : number.serial_number,
        vendor_invoice_id     : $scope.item.vendor_invoice_id,
        vendor_invoice_item_id: $scope.item.id
      }, 'product_serial_number');
    })
    .then(data => {
      $scope.form.$setPristine();

      messages.show($translate.instant('SERIAL_NUMBER_SPACE.SERIAL_NUMBER_SAVED'), 'success');

      $scope.serial_numbers = data;

      if ( number.id ) {
        $scope.crudGridAPI.toggleEditMode(number, index);
      }
      else {
        $scope.crudGridAPI.data = data;
      }

      return data;
    })
    .catch(err => {
      messages.error(err);

      return $q.reject(err);
    });
  };
}